import { Chip } from "@mui/material";
import { alpha } from "@mui/material/styles";

import { DutyScheduleDisplayStatus } from "@/api";
import { useTranslation } from "@/translations";

import { getStatusColor, getStatusLabelKey } from "./DutyScheduleStatusChip.utils";

const CHIP_BACKGROUND_OPACITY = 0.25;

interface Props {
  status: DutyScheduleDisplayStatus;
}

export function DutyScheduleStatusChip({ status }: Props) {
  const { t } = useTranslation();

  return (
    <Chip
      size="small"
      label={t(getStatusLabelKey(status))}
      sx={(theme) => {
        const color = getStatusColor(theme, status);
        return {
          bgcolor: alpha(color, CHIP_BACKGROUND_OPACITY),
          color,
          fontWeight: 600,
        };
      }}
    />
  );
}
